import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

export const RobotSpecs = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <tbody>
            {"B" in props.data && (
                <tr>
                    <td>{t('filters-robots.brand')}</td>
                    <td>{props.data["B"]}</td>
                </tr>
            )}
            {"M" in props.data && (
                <tr>
                    <td>{t('filters-robots.model')}</td>
                    <td>{props.data["M"]}</td>
                </tr>
            )}
            {"T" in props.data && (
                <tr>
                    <td>{t('filters-robots.type')}</td>
                    <td>{t('item-types.' + props.data["T"])}</td>
                </tr>
            )}
            {"A" in props.data && props.data["A"] > 0 && (
                <tr>
                    <td>{t('filters-robots.axes')}</td>
                    <td>{props.data["A"]}</td>
                </tr>
            )}
            {"P" in props.data && props.data["P"] > 0 && (
                <tr>
                    <td>{t('filters-robots.payload')}</td>
                    <td>{props.data["P"]} kg</td>
                </tr>
            )}
            {"R" in props.data && props.data["R"] > 0 && (
                <tr>
                    <td>{t('filters-robots.reach')}</td>
                    <td>{props.data["R"]} mm</td>
                </tr>
            )}
            {"E" in props.data && props.data["E"] > 0 && (
                <tr>
                    <td>{t('filters-robots.repeatability')}</td>
                    <td>{props.data["E"]} mm</td>
                </tr>
            )}
            {"W" in props.data && props.data["W"] > 0 && (
                <tr>
                    <td>{t('filters-robots.weight')}</td>
                    <td>{props.data["W"]} kg</td>
                </tr>
            )}
        </tbody>
    )
}